const SAFE_LOCAL_NAME = /^[A-Za-z_$][\w$]*$/;

/**
 * Evaluate a template that references a local by name (e.g. `request`, `item`).
 * Binds that name via Function's formal parameter so production minify cannot
 * rename it and break eval strings. Uses eval so expression and if/else
 * statement templates keep the same completion-value behavior as direct eval.
 *
 * Security: `localName` is restricted to a JS identifier. `code` must be a
 * trusted evaluation/display template from Toorak config or backend responses
 * (not free-form end-user input). The template body is passed to eval only as
 * a JSON-escaped string literal so it cannot break out of the Function source.
 */
export function evalWithNamedLocal(
  localName: string,
  code: string,
  localValue: unknown
): unknown {
  if (!SAFE_LOCAL_NAME.test(localName)) {
    throw new Error(`Invalid local name for eval: ${localName}`);
  }
  return new Function( // NOSONAR — trusted templates only; localName validated; see JSDoc
    localName,
    `return eval(${JSON.stringify(code)});`
  )(localValue);
}
